import React from 'react';
import { Loader, Dimmer } from 'semantic-ui-react';
import { compose, branch, renderComponent, mapProps, withState, withHandlers, withProps } from 'recompose';
import { withStpItems } from '../items/stp-items.helper';
import { withOnlineStatus } from 'op/components/offline';
import { container } from 'op/container';
import { connect } from 'react-redux';

const initialStpFormState = {
	"User_ID": undefined,
	"Item_ID": undefined,
	"STPMainDate": undefined,
	"STPMainComments": "",
	"STPMainPosition": "",
	"STPMainSig": "",
	"STPMainCompany": "",
	"STPTest12_24_0": false,
	"STPTest12_24_48": false,
	"STPTest12_24_79": false,
	"STPTest12_24_111": false,
	"STPTest12_30_0": false,
	"STPTest12_30_48": false,
	"STPTest12_30_79": false,
	"STPTest12_30_111": false,
	"STPTest12_32_0": false,
	"STPTest12_32_48": false,
	"STPTest12_32_79": false,
	"STPTest12_32_111": false,
	"STPTest12_36_0": false,
	"STPTest12_36_48": false,
	"STPTest12_36_79": false,
	"STPTest12_36_111": false,
	"STPTest3_1H": false,
	"STPTest3_1V": false,
	"STPTest3_15H": false,
	"STPTest3_15V": false,
	"STPTest3_2H": false,
	"STPTest3_2V": false,
	"STPTest4_5": false,
	"STPTest4_10": false,
	"STPTest4_15": false,
	"STPTest5_14": false,
	"STPTest5_16": false,
	"STPTest5_18": false,
	"STPTest5_20": false,
	"STPTest5_22": false,
	"STPTest5_24": false,
	"STPTest5_26": false,
	"STPTest5_28": false,
	"STPTest5_30": false,
	"STPTest6_Salt": false,
	"STPTest6_Sugar": false,
	"STPTestView": 0,
	"STPEmailAlert": false,
	"STPMainReportFile": "",
	"stpTest12Screenshot": "",
	"stpTest3Screenshot": "",
	"stpTest4Screenshot": "",
	"stpTest5Screenshot": "",
	"stpTest6Screenshot": ""
}

const getSingleViewStpForm = (userId, itemId) => {
	const form = { ...initialStpFormState };

	form.User_ID = userId;
	form.Item_ID = itemId;
	form.STPMainDate = new Date();
	form.STPTestView = 1;

	return [form]
};

const getDualViewStpForm = (userId, itemId) => {
	const verticalForm = { ...initialStpFormState };
	const horizontalForm = { ...initialStpFormState };

	verticalForm.User_ID = userId;
	verticalForm.Item_ID = itemId;
	verticalForm.STPMainDate = new Date();
	verticalForm.STPTestView = 3;

	horizontalForm.User_ID = userId;
	horizontalForm.Item_ID = itemId;
	horizontalForm.STPMainDate = new Date();
	horizontalForm.STPTestView = 2;

	return [verticalForm, horizontalForm]
};

export const withStpForm = compose(
	withOnlineStatus,
	withStpItems,
	branch(
		({ ready }) => !ready,
		renderComponent(() => <Dimmer active><Loader content='Loading' /></Dimmer>)
	),
	mapProps(({ items, match }) => ({
		item: items.find(item => item.item_ID.toString() === match.params.item_id),
		test_id: match.params.test_id,
	})),
	connect(({ stp, auth }) => ({
		loaded: stp.loaded,
		editing: stp.editing,
		user: auth.user,
	}), (dispatch) => ({
		dispatch,
	})),
	withProps(({ test_id, editing }) => ({
		isEditing: !!test_id,
		stpFormData: editing && editing.length && editing.find(item => item.id.toString() === test_id),
	})),
	withState('stpForm', 'setStpForm', ({ stpFormData, item, user, isEditing }) => {
		if (isEditing && stpFormData) {
			return stpFormData;
		} else {
			return {
				id: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15),
				item: item,
				data: item.stpType === 2 ? getDualViewStpForm(user.id, item.item_ID) : getSingleViewStpForm(user.id, item.item_ID),
			}
		}
	}),
	withHandlers({
		saveForm: ({ dispatch }) => async (data) => {
			dispatch(container.resolve('actions').save_stp_form(data));
		},
		removeForm: ({ dispatch }) => async (id) => {
			dispatch(container.resolve('actions').remove_stp_form({ id }));
		}
	})
);

export default {
	withItemSelection: withStpForm,
};
